import type { UserModel } from '@/apiTypes/UserTypes';

/** True when the user must complete account setup before accessing the app. */
export const isAccountSetupIncomplete = (user: UserModel | null | undefined): boolean => {
    if (!user?.id) {
        return false;
    }

    const profile = user.userProfile;
    if (!profile) {
        return true;
    }

    const {
        firstName,
        dateOfBirth,
        currentUsStateOrTerritoryId,
        agreedToTerms,
        agreedToPrivacyPolicy,
    } = profile;

    return (
        !firstName
        || !dateOfBirth
        || !currentUsStateOrTerritoryId
        || !agreedToTerms
        || !agreedToPrivacyPolicy
        || Boolean(profile.restrictedDueToAge)
    );
};

export const calculateAge = (dateOfBirth: Date) => {
    const birthDate = new Date(dateOfBirth);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();

    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }

    return age;
};
